export type ColumnMemory = {
  recall: () => string[] | null;
  remember: (columns: string[]) => void;
  forget: () => void;
};

export const columnMemoryFor = (personId: string, organizationId: string, table: string): ColumnMemory => {
  const key = `columns:${personId}:${organizationId}:${table}`;
  return {
    recall: () => {
      try {
        const stored = localStorage.getItem(key);
        if (!stored) return null;
        const parsed: unknown = JSON.parse(stored);
        return Array.isArray(parsed) && parsed.every((column) => typeof column === "string") ? parsed : null;
      } catch {
        return null;
      }
    },
    remember: (columns) => {
      try {
        localStorage.setItem(key, JSON.stringify(columns));
      } catch {
        return;
      }
    },
    forget: () => {
      try {
        localStorage.removeItem(key);
      } catch {
        return;
      }
    },
  };
};
